import { render, staticRenderFns } from "./EditHP.vue?vue&type=template&id=6404b0b4&"
import script from "./EditHP.vue?vue&type=script&lang=js&"
export * from "./EditHP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports